import { ArticleHeading1, ArticleHeading2, Image, UIText1, useDeviceType } from '@cian/ui-kit';
import React from 'react';
import cn from 'classnames';

import { X2_IMAGE_SIZE_MEDIA_QUERY } from '../../types/mediaQueries';

import * as styles from './styles.css';

export const RemoteFeaturesListItem: React.FC<{
  title: string;
  imageX1: string;
  imageX2: string;
  description: string;
}> = props => {
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';
  const TitleComponent = isMobile ? ArticleHeading2 : ArticleHeading1;

  return (
    <li className={cn(styles['item'])}>
      <Image
        display="block"
        src={props.imageX1}
        sources={[{ srcset: props.imageX2, media: X2_IMAGE_SIZE_MEDIA_QUERY }, { srcset: props.imageX1 }]}
        height={120}
        width={120}
        loading="lazy"
      />
      <TitleComponent as="h3">{props.title}</TitleComponent>
      <UIText1>{props.description}</UIText1>
    </li>
  );
};
